import React, { Component, Fragment } from 'react';
import DisplayImg from './22@2x.png';
import Img from '../../assets/Product/tick.svg';
import './Display.css';

export default class Display extends Component {
    render() {
        return (
            <Fragment>
                <div className="row display">
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <img src={DisplayImg} alt="display" className="displayImg" />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <h3 className="head">Monitor your Web Application with Threatspy</h3>
                        <h4 className="content-con">ThreatSpy enables you to predict the potential threat of cyber attack and provide you real-time reports for assessment of your web application and servers.</h4>
                        <div className="points">
                            <div className="point">
                                <img src={Img} alt="tick" className="tick" />
                                <h4 className="con">Analyze the risks associated with your Web Application </h4>
                            </div>
                            <div className="point">
                                <img src={Img} alt="tick" className="tick" />
                                <h4 className="con">Get instant Red Alert notifications when a attack is detected </h4>
                            </div>
                            <div className="point">
                                <img src={Img} alt="tick" className="tick" />
                                <h4 className="con">Protect your user data from getting exposed </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}